module.exports = __webpack_public_path__ + "static/media/main idea.61a85fcc.mp3";